import { ActionTree } from 'vuex';
import { RootState } from '@/types/store';
import { instantLottoState } from '@/types/instant';

export const actions: ActionTree<instantLottoState, RootState> = {
    actionAddToCart({ commit, state }, payload) {
        const cartClone = [...state.cartInstant];
        cartClone.push(payload);
        commit('ADD_TO_CART', cartClone);
    },
    actionRemoveCart({ commit }, payload) {
        commit('REMOVE_TO_CART', payload);
    },
};

export default actions;
